/* import __COLOCATED_TEMPLATE__ from './renewal-banner.hbs'; */
/* RESPONSIBLE TEAM: team-pricing-and-packaging */

import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  cadence: string;
}
interface Signature {
  Element: any;
  Args: Args;
}

const RenewalBanner = templateOnlyComponent<Signature>();
export default RenewalBanner;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Banners::RenewalBanner': typeof RenewalBanner;
    'banners/renewal-banner': typeof RenewalBanner;
  }
}
